export default __webpack_public_path__ + "static/media/banner-vagas.bb8703cd.jpg";